/**
 * Update the content of a <meta> tag, or add the tag to the document.
 *
 * @param {String} name  Tag name.
 * @param {String} value Tag content.
 * @returns {Boolean} Success or failure.
 */
const updateMeta = (name, value) => {
  if (! document) {
    return false;
  }

  let meta = document.querySelector(`meta[name="${name}"`);

  if (! meta) {
    // Try to find a meta tag that uses 'property' instead of 'name'.
    meta = document.querySelector(`meta[property="${name}"`);
  }

  if (! meta) {
    const target = document.head || document.body;

    if (! target) {
      return false;
    }

    meta = document.createElement('meta');
    meta.setAttribute('name', name);

    target.appendChild(meta);
  }

  meta.setAttribute('content', value);

  // Send an event with the updated meta tag name and value.
  window.dispatchEvent(
    new CustomEvent(
      'nsUpdateMeta',
      {
        detail: { name, value },
      },
    ),
  );

  return true;
};

export default updateMeta;
